export default {
  page: {
    title: "Gestión de lectores",
    subtitle:
      "Registra lectores POS, empareja terminales SumUp y vincúlalos a dispositivos",
    tabReaders: "Lectores",
    tabPresets: "Presets de lectores",
    newReader: "Nuevo lector",
    searchPlaceholder: "Buscar por número de serie, marca, modelo…",
    showMockReaders: "Mostrar terminales mock",
    filterPairing: "Emparejamiento",
    filterDeviceStatus: "Estado del dispositivo",
    filterStatusAll: "Todos",
    filterDeviceOnline: "En línea",
    filterDeviceUnavailable: "No disponible",
    filterDeviceUnknown: "No verificado",
    colBrand: "Marca",
    colSerial: "Número de serie",
    colRegion: "Región",
    colStatus: "Estado",
    colDevice: "Dispositivo asignado",
    colActions: "Acciones",
    emptySearch: "Ningún lector coincide con la búsqueda.",
    emptyDefault: "Aún no hay lectores registrados.",
    deleteTitle: "Eliminar lector",
    deleteConfirm:
      '¿Eliminar el lector "{{serial}}" del inventario? Esta acción no se puede deshacer.',
    deleteConfirmPaired:
      '¿Eliminar el lector "{{serial}}"? Se desemparejará de SumUp y se eliminará del inventario. Esta acción no se puede deshacer.',
    readerDeleted: "Lector eliminado",
    readerRenamed: "Número de serie del lector actualizado",
    readerCreated: "Lector registrado",
    readerPaired: "Lector emparejado con SumUp",
    readerUnpaired: "Lector desemparejado de SumUp",
    statusCreated: "Creado",
    statusNotPaired: "No emparejado",
    statusPaired: "Emparejado",
    deviceOnline: "En línea",
    deviceOffline: "Sin conexión",
    deviceBattery: "Batería: {{level}}%",
    deviceState: {
      IDLE: "En reposo",
      SELECTING_TIP: "Seleccionando propina",
      UPDATING_FIRMWARE: "Actualizando firmware",
      WAITING_FOR_CARD: "Esperando tarjeta",
      WAITING_FOR_PIN: "Esperando PIN",
      WAITING_FOR_SIGNATURE: "Esperando firma",
      UNKNOWN: "Estado desconocido",
    },
    deviceLastChecked: "Última verificación: {{time}}",
    deviceLastActivity: "Última actividad: {{time}}",
    refreshAllDeviceStatuses: "Actualizar estados de dispositivos",
    deviceStatusesRefreshed: "Estados de dispositivos actualizados",
    deviceStatusesRefreshedPartial:
      "Se actualizaron {{updated}} estado(s) de dispositivo; {{failed}} fallaron",
    deviceStatusesRefreshFailed:
      "No se pudo actualizar {{failed}} estado(s) de dispositivo",
    deviceStatusesNothingToRefresh:
      "No hay lectores SumUp emparejados para actualizar",
    regionLocked: "Bloqueada",
    regionLockedHint:
      "La región está bloqueada tras un pago correcto y no se puede cambiar",
    openAssignedDevice: "Ir al dispositivo",
    pairAction: "Emparejar con SumUp",
    unpairAction: "Desemparejar de SumUp",
    unlinkFromDeviceAction: "Desvincular del dispositivo",
    unlinkFromDeviceConfirm:
      '¿Desvincular el lector "{{serial}}" del dispositivo "{{device}}"? El emparejamiento con SumUp se mantiene; los pagos seguirán deshabilitados hasta que lo vuelvas a vincular.',
    readerUnlinkedFromDevice: "Lector desvinculado del dispositivo",
    changeRegionAction: "Cambiar región",
    regionUpdated: "Región del lector actualizada",
    unpairConfirm:
      '¿Desemparejar el lector "{{serial}}" de SumUp? Permanecerá en el inventario.',
  },
  renameModal: {
    title: "Renombrar lector",
    help: "Actualiza el número de serie del lector {{serial}}.",
    serialLabel: "Número de serie",
    serialPlaceholder: "Introduce el número de serie del dispositivo",
    serialRequired: "El número de serie es obligatorio",
  },
  createModal: {
    title: "Registrar lector",
    serialLabel: "Número de serie",
    serialPlaceholder: "Introduce el número de serie del dispositivo",
    serialRequired: "El número de serie es obligatorio",
    regionLabel: "Región",
    chooseRegion: "Seleccionar región…",
    regionRequired: "Selecciona una región",
    presetSelectorTitle: "Elige un preset de lector",
    presetsEmpty:
      "No hay presets. Crea uno primero en la pestaña Presets de lectores.",
    presetCardSpecs: "{{model}} • {{provider}} • {{flow}}",
    presetRequired: "Selecciona un preset de lector",
    submit: "Registrar lector",
  },
  pairModal: {
    title: "Emparejar lector SumUp",
    help: "Introduce el código de emparejamiento mostrado en el terminal {{serial}}.",
    codeLabel: "Código de emparejamiento",
    codePlaceholder: "8–9 caracteres",
    codeInvalid:
      "Introduce el código de emparejamiento de 8–9 caracteres del dispositivo SumUp.",
    submit: "Emparejar lector",
  },
  changeRegionModal: {
    title: "Cambiar región del lector",
    help: "Selecciona la región de pago para el lector {{serial}}.",
    regionLabel: "Región",
    regionRequired: "La región es obligatoria",
    unpairWarning:
      "Este lector está emparejado con SumUp. Cambiar la región lo eliminará de SumUp y borrará el emparejamiento local.",
    unpairConfirm:
      '¿Cambiar la región de "{{serial}}"? El emparejamiento SumUp se eliminará automáticamente.',
    submit: "Guardar región",
  },
  presets: {
    brandPlaceholder: "Marca (p. ej. SumUp)",
    modelPlaceholder: "Modelo (p. ej. Solo)",
    providerPlaceholder: "Proveedor (p. ej. SUMUP)",
    flowPlaceholder: "Flujo (p. ej. CLOUD_POS)",
    add: "Añadir preset",
    save: "Guardar cambios",
    updated: "Preset actualizado",
    created: "Preset creado",
    deleted: "Preset eliminado",
    deleteConfirm: '¿Eliminar el preset "{{name}}"?',
    deleteTitle: "Eliminar preset",
    editTitle: "Editar preset",
    colBrand: "Marca",
    colModel: "Modelo",
    colProvider: "Proveedor",
    colFlow: "Flujo",
    colActions: "Acciones",
    empty: "Aún no hay presets.",
    validationRequired: "Completa todos los campos del preset.",
  },
} as const;
